import {createContext} from 'react';
import {GwgAccelerator} from '@udemy-v2/career-accelerators';

export const AllGwgAcceleratorsContext = createContext<GwgAccelerator[] | undefined>(undefined);
